module.exports = __webpack_public_path__ + "assets/45ae7ae6b895aae52c63bf0e98580b65.mp3";